import { withTranslation } from 'react-i18next';

import ReactSelect from '../../../../components/ReactSelect';
import { GRID_SELECT } from '../../GscTools/selectStyles';
import { COMPARISON, COVERAGE, HOURLY_SEARCH_TYPE } from '../hours';
import { searchTypeLabel } from '../../GscTools/period';

/**
 * This report's own scope controls, in the shared grid beside the property.
 *
 * The source is shown but not chosen. Search Console reports hourly data for Web Search alone, so
 * the select carries that one option and is disabled: a reader scanning the bar sees the same
 * field they see on every other GSC tool, sees which surface this report reads, and sees that it
 * is not theirs to change. Printing it as bare text instead made it read as a caption on the
 * field beside it rather than as a field of its own.
 *
 * Coverage sits behind Apply with everything else even though it changes nothing about the
 * request. That is the cost of one rule — nothing on this page moves until Apply — and it is
 * worth paying: a control that silently re-totalled the figures while the others waited would
 * make it impossible to say which scope the numbers on screen belong to.
 */
function ExtraControls({ t, draft, onChange }) {
    const comparisonOptions = Object.values(COMPARISON).map((value) => ({
        value,
        label: t(`tools.latest_hours.comparisons.${value}`),
    }));

    const coverageOptions = Object.values(COVERAGE).map((value) => ({
        value,
        label: t(`tools.latest_hours.coverage_modes.${value}`),
    }));

    const sourceOptions = [
        { value: HOURLY_SEARCH_TYPE, label: searchTypeLabel(HOURLY_SEARCH_TYPE, t) },
    ];

    return (
        <>
            <div className="gsc-tool-field">
                <label>{t('tools.gsc.controls.search_type')}</label>
                <ReactSelect
                    options={sourceOptions}
                    value={sourceOptions[0]}
                    disabled
                    classname="gsc-tool-select"
                    controlStyles={GRID_SELECT}
                />
                <span className="gsc-tool-field-note">
                    {t('tools.latest_hours.controls.source_note')}
                </span>
            </div>

            <div className="gsc-tool-field">
                <label>{t('tools.gsc.controls.compare_with')}</label>
                <ReactSelect
                    options={comparisonOptions}
                    value={comparisonOptions.find((item) => item.value === draft.comparison)}
                    blurInputOnSelect={true}
                    classname="gsc-tool-select"
                    controlStyles={GRID_SELECT}
                    customeOnChange={(item) => onChange({ comparison: item.value })}
                />
                <span className="gsc-tool-field-note">
                    {t('tools.latest_hours.controls.compare_note')}
                </span>
            </div>

            <div className="gsc-tool-field">
                <label>{t('tools.latest_hours.controls.coverage')}</label>
                <ReactSelect
                    options={coverageOptions}
                    value={coverageOptions.find((item) => item.value === draft.coverage)}
                    blurInputOnSelect={true}
                    classname="gsc-tool-select"
                    controlStyles={GRID_SELECT}
                    customeOnChange={(item) => onChange({ coverage: item.value })}
                />
                <span className="gsc-tool-field-note">
                    {t(`tools.latest_hours.controls.coverage_note.${draft.coverage}`)}
                </span>
            </div>
        </>
    );
}

export default withTranslation()(ExtraControls);
